import * as React from 'react';
import { clsx } from 'clsx';
import { IMarkedListItem } from '../../types/offersData';

import { SeoMarkedListItem } from './components/SeoMarkedListItem';
import * as styles from './SeoMarkedList.css';
import { UIHeading2 } from '@cian/ui-kit';

interface ISeoMarkedListProps {
  items: IMarkedListItem[];
}

export const SeoMarkedList = ({ items }: ISeoMarkedListProps) => {
  const [isMounted, setIsMounted] = React.useState(false);

  React.useEffect(() => {
    setIsMounted(true);
  }, []);

  return (
    /*
      Блок в DOM находится наверху по SEO-требованиям, а визуально внизу.
      В плохих условиях (3G) браузерная отрисовка последующих блоков будет сдвигать его вниз, что портит CLS.
      Поэтому визуально отображаем блок позже - когда уже загружен и выполняется JS.
    */
    <div className={clsx(styles['container'], !isMounted && styles['visually-hidden'])}>
      <div className={styles['content']}>
        <UIHeading2>Люди часто спрашивают</UIHeading2>

        <div>
          {items
            .filter(item => !item.underH1)
            .map((item, index) => {
              const id = `SeoMarkedListItem_${index}`;

              return (
                <SeoMarkedListItem
                  key={id}
                  id={id}
                  title={item.title}
                  content={item.content}
                  expandedByDefault={item.expanded}
                />
              );
            })}
        </div>
      </div>
    </div>
  );
};
